import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { LayoutBreadcrumbItem } from 'src/modules/common/components/LayoutBreacrumbItem';
import { AdminLayout } from 'src/modules/common/layouts/AdminLayout';
import { getPartnerDashboardData } from 'src/modules/partner-dashboard/selectors/getPartnerDashboardData';
import { PartnerDashboardView } from 'src/modules/partner-dashboard/views/PartnerDashboardView';

export const PartnerDashboardPage = (): React.ReactElement => {
  const intl = useIntl();
  const dashboard = useSelector(getPartnerDashboardData);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: 'partner-dashboard/title' })}</title>
      </Helmet>

      <AdminLayout
        title={intl.formatMessage({ id: 'partner-dashboard/title' })}
        breadcrumbs={(
          <LayoutBreadcrumbItem to="/projects">
            {intl.formatMessage({ id: 'partner-dashboard/breadcrumbs/project' })}
          </LayoutBreadcrumbItem>
        )}
      >
        <PartnerDashboardView
          url={dashboard.url}
        />
      </AdminLayout>
    </>
  );
};
